import { create } from '~/utils/store/createStore';

interface AlfredFooterStackState {
  idsStack: string[];
  activeId: string | null;
}

interface AlfredFooterStackActions {
  push: (id: string) => void;
  remove: (id: string) => void;
}

type AlfredFooterStore = AlfredFooterStackState & AlfredFooterStackActions;

export const useAlfredFooterStore = create<AlfredFooterStore>((set) => ({
  idsStack: [],
  activeId: null,
  push: id =>
    set(state => {
      const nextStack = [...state.idsStack.filter(x => x !== id), id];
      return { idsStack: nextStack, activeId: nextStack.at(-1) };
    }),
  remove: id =>
    set(state => {
      const nextStack = state.idsStack.filter(x => x !== id);
      const nextActive = nextStack.length ? nextStack.at(-1) : null;
      return { idsStack: nextStack, activeId: nextActive };
    }),
}));
